<!-- Footer -->
<p class="clearfix mb-0">
  <span class="float-md-left d-block d-md-inline-block mt-25">
    COPYRIGHT &copy; {{ year }}
      <a class="ml-25 " href="https://axicoayurveda.in/" target="_blank" style="color: #436A3C; font-weight: 700;">Axico Health Care Private Limited</a>
    <span class="d-none d-sm-inline-block">, All rights Reserved</span>
  </span>
    <span class="float-md-right d-none d-md-block" style="margin-top: 2px !important;">
    <!--Hand-crafted & Made with <span [data-feather]="'heart'" style="color: black;"></span>-->
        Powered by <a class="ml-25 " href="https://volmint.com/" target="_blank"
                      style="color: #436A3C; font-weight: 700;">Volmint Technologies</a>
  </span>
</p>
<!--/ Footer -->

<!-- Move to top Button-->
<app-scroll-top *ngIf="coreConfig.layout.scrollTop"></app-scroll-top>

<!-- Buynow Button-->
<!--<div class="buy-now">
    <a href="https://1.envato.market/vuexy_admin" target="_blank" class="btn btn-danger"
       *ngIf="coreConfig.layout.buyNow"
    >Buy Now</a
    >
</div>-->
